import React, { useEffect } from 'react';

// Import the images for each artboard
// Adjust these paths to match your project structure
import artboard1Image from '../assets/ByMunicipality-Artboard_1.png';
import artboard2Image from '../assets/ByMunicipality-Artboard_2.png';
import artboard3Image from '../assets/ByMunicipality-Artboard_3.png';

/**
 * ByMunicipalityChart Component
 * 
 * A responsive visualization showing median age by sex with
 * three different layouts for various screen sizes.
 */
const ByMunicipality = () => {
  useEffect(() => {
    // Handle the ai2html resize function if it exists
    if (window.ResizeAi2html && typeof window.ResizeAi2html === 'function') {
      window.ResizeAi2html();
      
      // Add resize listener
      window.addEventListener('resize', window.ResizeAi2html);
      
      // Cleanup on unmount
      return () => {
        window.removeEventListener('resize', window.ResizeAi2html);
      };
    }
  }, []);

  // This is the ai2html output with image sources replaced
  const htmlContent = `


  <!-- Generated by ai2html v0.117.6 - 2025-03-11 08:06 -->
  <!-- ai file: ByMunicipality.ai -->
  <style media="screen,print">
	  #g-ByMunicipality-box ,
	  #g-ByMunicipality-box .g-artboard {
		  margin:0 auto;
	  }
	  #g-ByMunicipality-box p {
		  margin:0;
	  }
	  #g-ByMunicipality-box .g-aiAbs {
		  position:absolute;
	  }
	  #g-ByMunicipality-box .g-aiImg {
		  position:absolute;
		  top:0;
		  display:block;
		  width:100% !important;
	  }
	  #g-ByMunicipality-box .g-aiSymbol {
		  position: absolute;
		  box-sizing: border-box;
	  }
	  #g-ByMunicipality-box .g-aiPointText p { white-space: nowrap; }
	  #g-ByMunicipality-Artboard_1 {
		  position:relative;
		  overflow:hidden;
	  }
	  #g-ByMunicipality-Artboard_1 p {
		  font-weight:400;
		  line-height:17px;
		  height:auto;
		  opacity:1;
		  letter-spacing:0em;
		  font-size:14px;
		  text-align:left;
		  color:rgb(33,37,41);
		  text-transform:none;
		  padding-bottom:0;
		  padding-top:0;
		  mix-blend-mode:normal;
		  font-style:normal;
		  position:static;
	  }
	  #g-ByMunicipality-Artboard_1 .g-pstyle0 {
		  font-weight:300;
		  line-height:18px;
		  height:18px;
		  font-size:15px;
	  }
	  #g-ByMunicipality-Artboard_1 .g-pstyle1 {
		  font-weight:300;
		  height:17px;
		  text-align:center;
	  }
	  #g-ByMunicipality-Artboard_1 .g-pstyle2 {
		  font-weight:700;
		  height:17px;
		  text-align:center;
	  }
	  #g-ByMunicipality-Artboard_1 .g-pstyle3 {
		  font-weight:700;
		  height:17px;
		  text-align:right;
	  }
	  #g-ByMunicipality-Artboard_1 .g-pstyle4 {
		  font-weight:700;
		  height:17px;
	  }
	  #g-ByMunicipality-Artboard_1 .g-pstyle5 {
		  height:17px;
		  text-align:center;
	  }
	  #g-ByMunicipality-Artboard_1 .g-pstyle6 {
		  font-weight:700;
		  line-height:16px;
		  height:16px;
		  font-size:13px;
		  color:rgb(255,255,255);
	  }
	  #g-ByMunicipality-Artboard_1 .g-cstyle0 {
		  font-weight:300;
	  }
	  #g-ByMunicipality-Artboard_2 {
		  position:relative;
		  overflow:hidden;
	  }
	  #g-ByMunicipality-Artboard_2 p {
		  font-weight:400;
		  line-height:16px;
		  height:auto;
		  opacity:1;
		  letter-spacing:0em;
		  font-size:13px;
		  text-align:left;
		  color:rgb(33,37,41);
		  text-transform:none;
		  padding-bottom:0;
		  padding-top:0;
		  mix-blend-mode:normal;
		  font-style:normal;
		  position:static;
	  }
	  #g-ByMunicipality-Artboard_2 .g-pstyle0 {
		  font-weight:300;
		  height:16px;
	  }
	  #g-ByMunicipality-Artboard_2 .g-pstyle1 {
		  font-weight:700;
		  height:16px;
	  }
	  #g-ByMunicipality-Artboard_2 .g-pstyle2 {
		  font-weight:700;
		  height:16px;
		  text-align:right;
	  }
	  #g-ByMunicipality-Artboard_2 .g-pstyle3 {
		  font-weight:700;
		  height:16px;
		  text-align:justify;
	  }
	  #g-ByMunicipality-Artboard_2 .g-pstyle4 {
		  height:16px;
		  text-align:center;
	  }
	  #g-ByMunicipality-Artboard_2 .g-pstyle5 {
		  font-weight:700;
		  height:16px;
		  text-align:justify;
		  color:rgb(255,255,255);
	  }
	  #g-ByMunicipality-Artboard_3 {
		  position:relative;
		  overflow:hidden;
	  }
	  #g-ByMunicipality-Artboard_3 p {
		  font-weight:400;
		  line-height:16px;
		  height:auto;
		  opacity:1;
		  letter-spacing:0em;
		  font-size:13px;
		  text-align:left;
		  color:rgb(33,37,41);
		  text-transform:none;
		  padding-bottom:0;
		  padding-top:0;
		  mix-blend-mode:normal;
		  font-style:normal;
		  position:static;
	  }
	  #g-ByMunicipality-Artboard_3 .g-pstyle0 {
		  font-weight:300;
		  line-height:17px;
		  height:17px;
		  font-size:14px;
	  }
	  #g-ByMunicipality-Artboard_3 .g-pstyle1 {
		  font-weight:300;
		  height:16px;
	  }
	  #g-ByMunicipality-Artboard_3 .g-pstyle2 {
		  font-weight:700;
		  height:16px;
	  }
	  #g-ByMunicipality-Artboard_3 .g-pstyle3 {
		  height:16px;
	  }

	   /* Add media queries to control which artboard shows at different screen sizes */
    @media (min-width: 930px) {
      #g-ByMunicipality-Artboard_2, #g-ByMunicipality-Artboard_3 {
        display: none;
      }
    }
    
    @media (min-width: 560px) and (max-width: 929px) {
      #g-ByMunicipality-Artboard_1, #g-ByMunicipality-Artboard_3 {
        display: none;
      }
    }
    
    @media (max-width: 559px) {
      #g-ByMunicipality-Artboard_1, #g-ByMunicipality-Artboard_2 {
        display: none;
      }
    }
  
  
  </style>
  
  <div id="g-ByMunicipality-box" class="ai2html">
  
	  <!-- Artboard: Artboard_1 -->
	  <div id="g-ByMunicipality-Artboard_1" class="g-artboard" style="width:800px; height:591.920391196073px;" data-aspect-ratio="1.352" data-min-width="800">
  <div style=""></div>
		  <img id="g-ByMunicipality-Artboard_1-img" class="g-ByMunicipality-Artboard_1-img g-aiImg" alt="" src="${artboard1Image}"/>
		  <div id="g-ai0-1" class="g-md g-aiAbs g-aiPointText" style="top:3.3701%;margin-top:-9.9px;left:0%;width:343px;">
			  <p class="g-pstyle0">Provinces with candidates of highest median age</p>
		  </div>
		  <div id="g-ai0-2" class="g-md g-aiAbs g-aiPointText" style="top:6.3835%;margin-top:-17.8px;left:89.9716%;margin-left:-81.5px;width:163px;">
			  <p class="g-pstyle1">Philippines median age</p>
			  <p class="g-pstyle2"><span class="g-cstyle0"> </span>55 years old</p>
		  </div>
		  <div id="g-ai0-3" class="g-md g-aiAbs g-aiPointText" style="top:7.8364%;margin-top:-9.4px;right:59.7537%;width:205px;">
			  <p class="g-pstyle3">Number of House candidates</p>
		  </div>
		  <div id="g-ai0-4" class="g-md g-aiAbs g-aiPointText" style="top:7.8364%;margin-top:-9.4px;left:60.4547%;width:95px;">
			  <p class="g-pstyle4">Median age</p>
		  </div>
		  <div id="g-ai0-5" class="g-md g-aiAbs g-aiPointText" style="top:11.891%;margin-top:-9.4px;left:95.1144%;width:50px;">
			  <p class="g-pstyle4">70.5</p>
		  </div>
		  <div id="g-ai0-6" class="g-md g-aiAbs g-aiPointText" style="top:11.891%;margin-top:-9.4px;right:67.853%;width:30px;">
			  <p class="g-pstyle3">2</p>
		  </div>
		  <div id="g-ai0-7" class="g-md g-aiAbs g-aiPointText" style="top:11.891%;margin-top:-9.4px;left:50.3748%;margin-left:-46px;width:92px;">
			  <p class="g-pstyle5">Muntinlupa</p>
		  </div>
		  <div id="g-ai0-8" class="g-md g-aiAbs g-aiPointText" style="top:15.9456%;margin-top:-9.4px;left:50.3462%;margin-left:-48px;width:96px;">
			  <p class="g-pstyle5">Marinduque</p>
		  </div>
		  <div id="g-ai0-9" class="g-md g-aiAbs g-aiPointText" style="top:20.0002%;margin-top:-9.4px;left:50.3978%;margin-left:-72px;width:144px;">
			  <p class="g-pstyle5">Occidental Mindoro</p>
		  </div>
		  <div id="g-ai0-10" class="g-md g-aiAbs g-aiPointText" style="top:24.0548%;margin-top:-9.4px;left:50.3751%;margin-left:-65px;width:130px;">
			  <p class="g-pstyle5">Agusan del Norte</p>
		  </div>
		  <div id="g-ai0-11" class="g-md g-aiAbs g-aiPointText" style="top:28.1094%;margin-top:-9.4px;left:50.3621%;margin-left:-60.5px;width:121px;">
			  <p class="g-pstyle5">Lanao del Norte</p>
		  </div>
		  <div id="g-ai0-12" class="g-md g-aiAbs g-aiPointText" style="top:32.164%;margin-top:-9.4px;left:50.3763%;margin-left:-35px;width:70px;">
			  <p class="g-pstyle5">Antique</p>
		  </div>
		  <div id="g-ai0-13" class="g-md g-aiAbs g-aiPointText" style="top:36.2186%;margin-top:-9.4px;left:50.3817%;margin-left:-41px;width:82px;">
			  <p class="g-pstyle5">Guimaras</p>
		  </div>
		  <div id="g-ai0-14" class="g-md g-aiAbs g-aiPointText" style="top:40.2732%;margin-top:-9.4px;left:50.3735%;margin-left:-28.5px;width:57px;">
			  <p class="g-pstyle5">Aklan</p>
		  </div>
		  <div id="g-ai0-15" class="g-md g-aiAbs g-aiPointText" style="top:44.3278%;margin-top:-9.4px;left:50.3657%;margin-left:-40.5px;width:81px;">
			  <p class="g-pstyle5">Camiguin</p>
		  </div>
		  <div id="g-ai0-16" class="g-md g-aiAbs g-aiPointText" style="top:48.3824%;margin-top:-9.4px;left:91.553%;width:50px;">
			  <p class="g-pstyle4">64.0</p>
		  </div>
		  <div id="g-ai0-17" class="g-md g-aiAbs g-aiPointText" style="top:48.3824%;margin-top:-9.4px;left:50.3876%;margin-left:-65.5px;width:131px;">
			  <p class="g-pstyle5">Davao Occidental</p>
		  </div>
		  <div id="g-ai0-18" class="g-md g-aiAbs g-aiPointText" style="top:55.9109%;margin-top:-9.9px;left:0%;width:338px;">
			  <p class="g-pstyle0">Provinces with candidates of lowest median age</p>
		  </div>
		  <div id="g-ai0-19" class="g-md g-aiAbs g-aiPointText" style="top:61.053%;margin-top:-9.4px;left:50.4129%;margin-left:-79px;width:158px;">
			  <p class="g-pstyle5">Zamboanga del Norte</p>
		  </div>
		  <div id="g-ai0-20" class="g-md g-aiAbs g-aiPointText" style="top:61.1268%;margin-top:-8.8px;left:81.8147%;width:48px;">
			  <p class="g-pstyle6">46.0</p>
		  </div>
		  <div id="g-ai0-21" class="g-md g-aiAbs g-aiPointText" style="top:65.1076%;margin-top:-9.4px;left:50.4133%;margin-left:-33.5px;width:67px;">
			  <p class="g-pstyle5">Quirino</p>
		  </div>
		  <div id="g-ai0-22" class="g-md g-aiAbs g-aiPointText" style="top:69.1622%;margin-top:-9.4px;left:50.3685%;margin-left:-56.5px;width:113px;">
			  <p class="g-pstyle5">Sultan Kudarat</p>
		  </div>
		  <div id="g-ai0-23" class="g-md g-aiAbs g-aiPointText" style="top:73.2168%;margin-top:-9.4px;left:50.3638%;margin-left:-53px;width:106px;">
			  <p class="g-pstyle5">Mandaluyong</p>
		  </div>
		  <div id="g-ai0-24" class="g-md g-aiAbs g-aiPointText" style="top:77.2714%;margin-top:-9.4px;left:50.394%;margin-left:-40px;width:80px;">
			  <p class="g-pstyle5">San Juan</p>
		  </div>
		  <div id="g-ai0-25" class="g-md g-aiAbs g-aiPointText" style="top:81.326%;margin-top:-9.4px;left:50.3611%;margin-left:-36.5px;width:73px;">
			  <p class="g-pstyle5">Benguet</p>
		  </div>
		  <div id="g-ai0-26" class="g-md g-aiAbs g-aiPointText" style="top:85.3806%;margin-top:-9.4px;left:50.3864%;margin-left:-58px;width:116px;">
			  <p class="g-pstyle5">Surigao del Sur</p>
		  </div>
		  <div id="g-ai0-27" class="g-md g-aiAbs g-aiPointText" style="top:89.4352%;margin-top:-9.4px;left:50.3925%;margin-left:-28.5px;width:57px;">
			  <p class="g-pstyle5">Capiz</p>
		  </div>
		  <div id="g-ai0-28" class="g-md g-aiAbs g-aiPointText" style="top:93.4898%;margin-top:-9.4px;left:50.392%;margin-left:-56.5px;width:113px;">
			  <p class="g-pstyle5">Davao Oriental</p>
		  </div>
		  <div id="g-ai0-29" class="g-md g-aiAbs g-aiPointText" style="top:97.5444%;margin-top:-9.4px;left:50.3846%;margin-left:-84px;width:168px;">
			  <p class="g-pstyle5">Maguindanao del Norte</p>
		  </div>
		  <div id="g-ai0-30" class="g-md g-aiAbs g-aiPointText" style="top:97.6182%;margin-top:-8.8px;left:74.6912%;width:48px;">
			  <p class="g-pstyle6">33.0</p>
		  </div>
	  </div>
  
	  <!-- Artboard: Artboard_2 -->
	  <div id="g-ByMunicipality-Artboard_2" class="g-artboard" style="width:560px; height:597.515075079595px;" data-aspect-ratio="0.937" data-min-width="560" data-max-width="799">
  <div style=""></div>
		  <img id="g-ByMunicipality-Artboard_2-img" class="g-ByMunicipality-Artboard_2-img g-aiImg" alt="" src="${artboard2Image}"/>
		  <div id="g-ai1-1" class="g-sm g-aiAbs g-aiPointText" style="top:4.9241%;margin-top:-24.4px;left:85.2176%;width:93px;">
			  <p class="g-pstyle0">Philippines</p>
			  <p class="g-pstyle0">median age</p>
			  <p class="g-pstyle1">55 years old</p>
		  </div>
		  <div id="g-ai1-2" class="g-sm g-aiAbs g-aiPointText" style="top:2.9827%;margin-top:-8.8px;left:0.1783%;width:300px;">
			  <p class="g-pstyle0">Provinces with candidates of highest median age</p>
		  </div>
		  <div id="g-ai1-3" class="g-sm g-aiAbs g-aiPointText" style="top:7.334%;margin-top:-8.8px;right:63.226%;width:192px;">
			  <p class="g-pstyle2">Number of House candidates</p>
		  </div>
		  <div id="g-ai1-4" class="g-sm g-aiAbs g-aiPointText" style="top:7.334%;margin-top:-8.8px;left:65.3297%;width:90px;">
			  <p class="g-pstyle3">Median age</p>
		  </div>
		  <div id="g-ai1-5" class="g-sm g-aiAbs g-aiPointText" style="top:11.3507%;margin-top:-8.8px;left:92.265%;width:48px;">
			  <p class="g-pstyle3">70.5</p>
		  </div>
		  <div id="g-ai1-6" class="g-sm g-aiAbs g-aiPointText" style="top:11.518%;margin-top:-8.8px;right:70.642%;width:29px;">
			  <p class="g-pstyle2">2</p>
		  </div>
		  <div id="g-ai1-7" class="g-sm g-aiAbs g-aiPointText" style="top:11.518%;margin-top:-8.8px;left:51.0719%;margin-left:-43.5px;width:87px;">
			  <p class="g-pstyle4">Muntinlupa</p>
		  </div>
		  <div id="g-ai1-8" class="g-sm g-aiAbs g-aiPointText" style="top:15.5347%;margin-top:-8.8px;left:51.0595%;margin-left:-45.5px;width:91px;">
			  <p class="g-pstyle4">Marinduque</p>
		  </div>
		  <div id="g-ai1-9" class="g-sm g-aiAbs g-aiPointText" style="top:19.5513%;margin-top:-8.8px;left:51.0769%;margin-left:-67.5px;width:135px;">
			  <p class="g-pstyle4">Occidental Mindoro</p>
		  </div>
		  <div id="g-ai1-10" class="g-sm g-aiAbs g-aiPointText" style="top:23.5679%;margin-top:-8.8px;left:51.0468%;margin-left:-61px;width:122px;">
			  <p class="g-pstyle4">Agusan del Norte</p>
		  </div>
		  <div id="g-ai1-11" class="g-sm g-aiAbs g-aiPointText" style="top:27.5846%;margin-top:-8.8px;left:51.0614%;margin-left:-57px;width:114px;">
			  <p class="g-pstyle4">Lanao del Norte</p>
		  </div>
		  <div id="g-ai1-12" class="g-sm g-aiAbs g-aiPointText" style="top:31.6012%;margin-top:-8.8px;left:51.0231%;margin-left:-33px;width:66px;">
			  <p class="g-pstyle4">Antique</p>
		  </div>
		  <div id="g-ai1-13" class="g-sm g-aiAbs g-aiPointText" style="top:35.6178%;margin-top:-8.8px;left:51.1066%;margin-left:-39px;width:78px;">
			  <p class="g-pstyle4">Guimaras</p>
		  </div>
		  <div id="g-ai1-14" class="g-sm g-aiAbs g-aiPointText" style="top:39.6345%;margin-top:-8.8px;left:51.0255%;margin-left:-27px;width:54px;">
			  <p class="g-pstyle4">Aklan</p>
		  </div>
		  <div id="g-ai1-15" class="g-sm g-aiAbs g-aiPointText" style="top:43.6511%;margin-top:-8.8px;left:51.079%;margin-left:-38.5px;width:77px;">
			  <p class="g-pstyle4">Camiguin</p>
		  </div>
		  <div id="g-ai1-16" class="g-sm g-aiAbs g-aiPointText" style="top:47.6678%;margin-top:-8.8px;left:51.0698%;margin-left:-61.5px;width:123px;">
			  <p class="g-pstyle4">Davao Occidental</p>
		  </div>
		  <div id="g-ai1-17" class="g-sm g-aiAbs g-aiPointText" style="top:47.6678%;margin-top:-8.8px;left:94.9342%;width:48px;">
			  <p class="g-pstyle1">64.0</p>
		  </div>
		  <div id="g-ai1-18" class="g-sm g-aiAbs g-aiPointText" style="top:55.1989%;margin-top:-8.8px;left:0.2941%;width:296px;">
			  <p class="g-pstyle0">Provinces with candidates of lowest median age</p>
		  </div>
		  <div id="g-ai1-19" class="g-sm g-aiAbs g-aiPointText" style="top:60.0523%;margin-top:-8.8px;left:81.1071%;width:48px;">
			  <p class="g-pstyle5">46.0</p>
		  </div>
		  <div id="g-ai1-20" class="g-sm g-aiAbs g-aiPointText" style="top:60.2197%;margin-top:-8.8px;left:51.0902%;margin-left:-74px;width:148px;">
			  <p class="g-pstyle4">Zamboanga del Norte</p>
		  </div>
		  <div id="g-ai1-21" class="g-sm g-aiAbs g-aiPointText" style="top:64.2363%;margin-top:-8.8px;left:51.0461%;margin-left:-31.5px;width:63px;">
			  <p class="g-pstyle4">Quirino</p>
		  </div>
		  <div id="g-ai1-22" class="g-sm g-aiAbs g-aiPointText" style="top:68.253%;margin-top:-8.8px;left:51.1015%;margin-left:-53.5px;width:107px;">
			  <p class="g-pstyle4">Sultan Kudarat</p>
		  </div>
		  <div id="g-ai1-23" class="g-sm g-aiAbs g-aiPointText" style="top:72.2696%;margin-top:-8.8px;left:51.0506%;margin-left:-50px;width:100px;">
			  <p class="g-pstyle4">Mandaluyong</p>
		  </div>
		  <div id="g-ai1-24" class="g-sm g-aiAbs g-aiPointText" style="top:76.2862%;margin-top:-8.8px;left:51.1034%;margin-left:-38px;width:76px;">
			  <p class="g-pstyle4">San Juan</p>
		  </div>
		  <div id="g-ai1-25" class="g-sm g-aiAbs g-aiPointText" style="top:80.3029%;margin-top:-8.8px;left:51.1043%;margin-left:-35px;width:70px;">
			  <p class="g-pstyle4">Benguet</p>
		  </div>
		  <div id="g-ai1-26" class="g-sm g-aiAbs g-aiPointText" style="top:84.3195%;margin-top:-8.8px;left:51.0551%;margin-left:-54.5px;width:109px;">
			  <p class="g-pstyle4">Surigao del Sur</p>
		  </div>
		  <div id="g-ai1-27" class="g-sm g-aiAbs g-aiPointText" style="top:88.3361%;margin-top:-8.8px;left:51.044%;margin-left:-27px;width:54px;">
			  <p class="g-pstyle4">Capiz</p>
		  </div>
		  <div id="g-ai1-28" class="g-sm g-aiAbs g-aiPointText" style="top:92.3528%;margin-top:-8.8px;left:51.0435%;margin-left:-53px;width:106px;">
			  <p class="g-pstyle4">Davao Oriental</p>
		  </div>
		  <div id="g-ai1-29" class="g-sm g-aiAbs g-aiPointText" style="top:96.2021%;margin-top:-8.8px;left:75.1305%;width:48px;">
			  <p class="g-pstyle5">33.0</p>
		  </div>
		  <div id="g-ai1-30" class="g-sm g-aiAbs g-aiPointText" style="top:96.3694%;margin-top:-8.8px;left:51.1165%;margin-left:-79px;width:158px;">
			  <p class="g-pstyle4">Maguindanao del Norte</p>
		  </div>
	  </div>
  
	  <!-- Artboard: Artboard_3 -->
	  <div id="g-ByMunicipality-Artboard_3" class="g-artboard" style="max-width: 330px;max-height: 1246px" data-aspect-ratio="0.265" data-min-width="0" data-max-width="559">
  <div style="padding: 0 0 377.4474% 0;"></div>
		  <img id="g-ByMunicipality-Artboard_3-img" class="g-ByMunicipality-Artboard_3-img g-aiImg" alt="" src="${artboard3Image}"/>
		  <div id="g-ai2-1" class="g-sm g-aiAbs g-aiPointText" style="top:1.2352%;margin-top:-9.4px;left:0.3026%;width:322px;">
			  <p class="g-pstyle0">Provinces with candidates of highest median age</p>
		  </div>
		  <div id="g-ai2-2" class="g-sm g-aiAbs g-aiPointText" style="top:3.9839%;margin-top:-16.6px;left:73.2388%;width:93px;">
			  <p class="g-pstyle1">Philippines</p>
			  <p class="g-pstyle2">55 years old</p>
		  </div>
		  <div id="g-ai2-3" class="g-sm g-aiAbs g-aiPointText" style="top:4.5619%;margin-top:-8.8px;left:42.9594%;width:90px;">
			  <p class="g-pstyle2">Median age</p>
		  </div>
		  <div id="g-ai2-4" class="g-sm g-aiAbs g-aiPointText" style="top:6.4887%;margin-top:-8.8px;left:0.3026%;width:87px;">
			  <p class="g-pstyle3">Muntinlupa</p>
		  </div>
		  <div id="g-ai2-5" class="g-sm g-aiAbs g-aiPointText" style="top:8.4155%;margin-top:-8.8px;left:0.3026%;width:91px;">
			  <p class="g-pstyle3">Marinduque</p>
		  </div>
		  <div id="g-ai2-6" class="g-sm g-aiAbs g-aiPointText" style="top:10.3424%;margin-top:-8.8px;left:0.3026%;width:135px;">
			  <p class="g-pstyle3">Occidental Mindoro</p>
		  </div>
		  <div id="g-ai2-7" class="g-sm g-aiAbs g-aiPointText" style="top:12.2692%;margin-top:-8.8px;left:0.3026%;width:122px;">
			  <p class="g-pstyle3">Agusan del Norte</p>
		  </div>
		  <div id="g-ai2-8" class="g-sm g-aiAbs g-aiPointText" style="top:14.196%;margin-top:-8.8px;left:0.3026%;width:114px;">
			  <p class="g-pstyle3">Lanao del Norte</p>
		  </div>
		  <div id="g-ai2-9" class="g-sm g-aiAbs g-aiPointText" style="top:16.1228%;margin-top:-8.8px;left:0.3026%;width:66px;">
			  <p class="g-pstyle3">Antique</p>
		  </div>
		  <div id="g-ai2-10" class="g-sm g-aiAbs g-aiPointText" style="top:18.0496%;margin-top:-8.8px;left:0.3026%;width:78px;">
			  <p class="g-pstyle3">Guimaras</p>
		  </div>
		  <div id="g-ai2-11" class="g-sm g-aiAbs g-aiPointText" style="top:19.9765%;margin-top:-8.8px;left:0.3026%;width:54px;">
			  <p class="g-pstyle3">Aklan</p>
		  </div>
		  <div id="g-ai2-12" class="g-sm g-aiAbs g-aiPointText" style="top:21.9033%;margin-top:-8.8px;left:0.3026%;width:77px;">
			  <p class="g-pstyle3">Camiguin</p>
		  </div>
		  <div id="g-ai2-13" class="g-sm g-aiAbs g-aiPointText" style="top:23.8301%;margin-top:-8.8px;left:0.3026%;width:123px;">
			  <p class="g-pstyle3">Davao Occidental</p>
		  </div>
		  <div id="g-ai2-14" class="g-sm g-aiAbs g-aiPointText" style="top:27.0415%;margin-top:-8.8px;left:42.9597%;width:192px;">
			  <p class="g-pstyle2">Number of House candidates</p>
		  </div>
		  <div id="g-ai2-15" class="g-sm g-aiAbs g-aiPointText" style="top:28.9683%;margin-top:-8.8px;left:0.3026%;width:87px;">
			  <p class="g-pstyle3">Muntinlupa</p>
		  </div>
		  <div id="g-ai2-16" class="g-sm g-aiAbs g-aiPointText" style="top:30.8951%;margin-top:-8.8px;left:0.3026%;width:91px;">
			  <p class="g-pstyle3">Marinduque</p>
		  </div>
		  <div id="g-ai2-17" class="g-sm g-aiAbs g-aiPointText" style="top:32.8219%;margin-top:-8.8px;left:0.3026%;width:135px;">
			  <p class="g-pstyle3">Occidental Mindoro</p>
		  </div>
		  <div id="g-ai2-18" class="g-sm g-aiAbs g-aiPointText" style="top:34.7487%;margin-top:-8.8px;left:0.3026%;width:122px;">
			  <p class="g-pstyle3">Agusan del Norte</p>
		  </div>
		  <div id="g-ai2-19" class="g-sm g-aiAbs g-aiPointText" style="top:36.6755%;margin-top:-8.8px;left:0.3026%;width:114px;">
			  <p class="g-pstyle3">Lanao del Norte</p>
		  </div>
		  <div id="g-ai2-20" class="g-sm g-aiAbs g-aiPointText" style="top:38.6023%;margin-top:-8.8px;left:0.3026%;width:66px;">
			  <p class="g-pstyle3">Antique</p>
		  </div>
		  <div id="g-ai2-21" class="g-sm g-aiAbs g-aiPointText" style="top:40.5292%;margin-top:-8.8px;left:0.3026%;width:78px;">
			  <p class="g-pstyle3">Guimaras</p>
		  </div>
		  <div id="g-ai2-22" class="g-sm g-aiAbs g-aiPointText" style="top:42.456%;margin-top:-8.8px;left:0.3026%;width:54px;">
			  <p class="g-pstyle3">Aklan</p>
		  </div>
		  <div id="g-ai2-23" class="g-sm g-aiAbs g-aiPointText" style="top:44.3828%;margin-top:-8.8px;left:0.3026%;width:77px;">
			  <p class="g-pstyle3">Camiguin</p>
		  </div>
		  <div id="g-ai2-24" class="g-sm g-aiAbs g-aiPointText" style="top:46.3096%;margin-top:-8.8px;left:0.3026%;width:123px;">
			  <p class="g-pstyle3">Davao Occidental</p>
		  </div>
		  <div id="g-ai2-25" class="g-sm g-aiAbs g-aiPointText" style="top:51.7339%;margin-top:-9.4px;left:0.3032%;width:317px;">
			  <p class="g-pstyle0">Provinces with candidates of lowest median age</p>
		  </div>
		  <div id="g-ai2-26" class="g-sm g-aiAbs g-aiPointText" style="top:54.1614%;margin-top:-16.6px;left:71.0282%;width:93px;">
			  <p class="g-pstyle1">Philippines</p>
			  <p class="g-pstyle2">55 years old</p>
		  </div>
		  <div id="g-ai2-27" class="g-sm g-aiAbs g-aiPointText" style="top:54.7395%;margin-top:-8.8px;left:43.2533%;width:90px;">
			  <p class="g-pstyle2">Median age</p>
		  </div>
		  <div id="g-ai2-28" class="g-sm g-aiAbs g-aiPointText" style="top:56.7466%;margin-top:-8.8px;left:0.3029%;width:148px;">
			  <p class="g-pstyle3">Zamboanga del Norte</p>
		  </div>
		  <div id="g-ai2-29" class="g-sm g-aiAbs g-aiPointText" style="top:58.6734%;margin-top:-8.8px;left:0.3029%;width:63px;">
			  <p class="g-pstyle3">Quirino</p>
		  </div>
		  <div id="g-ai2-30" class="g-sm g-aiAbs g-aiPointText" style="top:60.6002%;margin-top:-8.8px;left:0.3029%;width:107px;">
			  <p class="g-pstyle3">Sultan Kudarat</p>
		  </div>
		  <div id="g-ai2-31" class="g-sm g-aiAbs g-aiPointText" style="top:62.527%;margin-top:-8.8px;left:0.3029%;width:100px;">
			  <p class="g-pstyle3">Mandaluyong</p>
		  </div>
		  <div id="g-ai2-32" class="g-sm g-aiAbs g-aiPointText" style="top:64.4538%;margin-top:-8.8px;left:0.3029%;width:76px;">
			  <p class="g-pstyle3">San Juan</p>
		  </div>
		  <div id="g-ai2-33" class="g-sm g-aiAbs g-aiPointText" style="top:66.3807%;margin-top:-8.8px;left:0.3029%;width:70px;">
			  <p class="g-pstyle3">Benguet</p>
		  </div>
		  <div id="g-ai2-34" class="g-sm g-aiAbs g-aiPointText" style="top:68.3075%;margin-top:-8.8px;left:0.3029%;width:109px;">
			  <p class="g-pstyle3">Surigao del Sur</p>
		  </div>
		  <div id="g-ai2-35" class="g-sm g-aiAbs g-aiPointText" style="top:70.2343%;margin-top:-8.8px;left:0.3029%;width:54px;">
			  <p class="g-pstyle3">Capiz</p>
		  </div>
		  <div id="g-ai2-36" class="g-sm g-aiAbs g-aiPointText" style="top:72.1611%;margin-top:-8.8px;left:0.3029%;width:106px;">
			  <p class="g-pstyle3">Davao Oriental</p>
		  </div>
		  <div id="g-ai2-37" class="g-sm g-aiAbs g-aiPointText" style="top:74.0879%;margin-top:-8.8px;left:0.3029%;width:158px;">
			  <p class="g-pstyle3">Maguindanao del Norte</p>
		  </div>
		  <div id="g-ai2-38" class="g-sm g-aiAbs g-aiPointText" style="top:78.343%;margin-top:-8.8px;left:42.9597%;width:192px;">
			  <p class="g-pstyle2">Number of House candidates</p>
		  </div>
		  <div id="g-ai2-39" class="g-sm g-aiAbs g-aiPointText" style="top:80.1093%;margin-top:-8.8px;left:0.3032%;width:148px;">
			  <p class="g-pstyle3">Zamboanga del Norte</p>
		  </div>
		  <div id="g-ai2-40" class="g-sm g-aiAbs g-aiPointText" style="top:81.8755%;margin-top:-8.8px;left:0.3032%;width:63px;">
			  <p class="g-pstyle3">Quirino</p>
		  </div>
		  <div id="g-ai2-41" class="g-sm g-aiAbs g-aiPointText" style="top:83.9629%;margin-top:-8.8px;left:0.3032%;width:107px;">
			  <p class="g-pstyle3">Sultan Kudarat</p>
		  </div>
		  <div id="g-ai2-42" class="g-sm g-aiAbs g-aiPointText" style="top:85.8897%;margin-top:-8.8px;left:0.3032%;width:100px;">
			  <p class="g-pstyle3">Mandaluyong</p>
		  </div>
		  <div id="g-ai2-43" class="g-sm g-aiAbs g-aiPointText" style="top:87.8165%;margin-top:-8.8px;left:0.3032%;width:76px;">
			  <p class="g-pstyle3">San Juan</p>
		  </div>
		  <div id="g-ai2-44" class="g-sm g-aiAbs g-aiPointText" style="top:89.7434%;margin-top:-8.8px;left:0.3032%;width:70px;">
			  <p class="g-pstyle3">Benguet</p>
		  </div>
		  <div id="g-ai2-45" class="g-sm g-aiAbs g-aiPointText" style="top:91.6702%;margin-top:-8.8px;left:0.3032%;width:109px;">
			  <p class="g-pstyle3">Surigao del Sur</p>
		  </div>
		  <div id="g-ai2-46" class="g-sm g-aiAbs g-aiPointText" style="top:93.4364%;margin-top:-8.8px;left:0.3032%;width:54px;">
			  <p class="g-pstyle3">Capiz</p>
		  </div>
		  <div id="g-ai2-47" class="g-sm g-aiAbs g-aiPointText" style="top:95.5238%;margin-top:-8.8px;left:0.3032%;width:106px;">
			  <p class="g-pstyle3">Davao Oriental</p>
		  </div>
		  <div id="g-ai2-48" class="g-sm g-aiAbs g-aiPointText" style="top:97.4506%;margin-top:-8.8px;left:0.3032%;width:158px;">
			  <p class="g-pstyle3">Maguindanao del Norte</p>
		  </div>
	  </div>
  
  </div>
  
  <!-- End ai2html - 2025-03-11 08:06 -->
  
  
  `;

  return (
    <div 
      className="bymunicipality-chart-container"
      dangerouslySetInnerHTML={{ __html: htmlContent }}
    />
  );
};

export default ByMunicipality;